import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { TabContent, TabPane } from 'reactstrap';
import { useMutation, useQuery } from '@apollo/client';
import RBAC_TABS from 'components/RBAC_TABS';
import Heading from 'components/Heading';
import Loader from 'components/common/Loader';
import { APP_UI_SETTINGS, QUERY_UI_SETTINGS } from './ApplicationUIGraphQL';
import {
  applicationUIList,
  applicationUITabHeading,
  SETTING_UPDATE,
} from './constant';
import PromotionalImages from './components/PromotionalImages';
import AboutUs from './components/AboutUs';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsAndConditions from './components/TermsAndConditions';
import MarketFreeze from './components/MarketFreeze';
import FAQ from './components/FAQ';
import News from './components/News';
import UserVerificationDocument from './components/UserVerificationDocument';
import DownloadAPK from './components/DownloadAPK';

const ApplicationUI = () => {
  const [activeTab, setActiveTab] = useState(applicationUIList.DOWNLOAD_APK);

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const { data, loading, error, refetch } = useQuery(QUERY_UI_SETTINGS, {
    fetchPolicy: 'network-only',
  });

  const [saveUISetting] = useMutation(APP_UI_SETTINGS, {
    onCompleted: (mutationData) => {
      if (mutationData?.saveUISetting) {
        toast.success(SETTING_UPDATE);
      }
    },
    onError: ({ graphQLErrors }) => {
      graphQLErrors.forEach(({ message }) => {
        toast.error(message);
      });
    },
  });

  const handleSave = async (values) => {
    try {
      await saveUISetting({
        variables: {
          appUISetting: {
            id: values.id,
            settingName: values.settingName,
            settingValue: values.settingValue,
            isActive: values.isActive,
          },
        },
      });
      refetch();
    } catch (err) {
      toast.error(err?.message || 'Something went wrong');
    }
  };

  if (loading) return <Loader />;
  if (error) return `There is an error on this page : ${error.message}`;
  if (!data.uiSettings) return 'UI setting not available.';

  const { ABOUT_US, PRIVACY_POLICY, TERMS_OF_USE } = data.uiSettings;

  return (
    <div className="application-page">
      <div className="top-head">
        <Heading title="Application UI" />
      </div>

      <div className="tab-sec">
        <RBAC_TABS
          tabs={[...applicationUITabHeading]}
          selectedTab={activeTab}
          onTabChange={toggle}
          className="outer-tab w-auto"
        />
        <TabContent activeTab={activeTab}>
          <TabPane tabId={applicationUIList.DOWNLOAD_APK}>
            {activeTab === applicationUIList.DOWNLOAD_APK && <DownloadAPK />}
          </TabPane>
          <TabPane tabId={applicationUIList.FAQ}>
            {activeTab === applicationUIList.FAQ && <FAQ />}
          </TabPane>
          <TabPane tabId={applicationUIList.PromotionalImages}>
            {activeTab === applicationUIList.PromotionalImages && (
              <PromotionalImages saveUISetting={saveUISetting} />
            )}
          </TabPane>
          <TabPane tabId={applicationUIList.TermsAndConditions}>
            {activeTab === applicationUIList.TermsAndConditions && (
              <TermsAndConditions
                handleSubmit={handleSave}
                data={TERMS_OF_USE}
              />
            )}
          </TabPane>
          <TabPane tabId={applicationUIList.AboutUs}>
            {activeTab === applicationUIList.AboutUs && (
              <AboutUs handleSubmit={handleSave} data={ABOUT_US} />
            )}
          </TabPane>
          <TabPane tabId={applicationUIList.PrivacyPolicy}>
            {activeTab === applicationUIList.PrivacyPolicy && (
              <PrivacyPolicy handleSubmit={handleSave} data={PRIVACY_POLICY} />
            )}
          </TabPane>
          <TabPane tabId={applicationUIList.MarketFreeze}>
            {activeTab === applicationUIList.MarketFreeze && <MarketFreeze />}
          </TabPane>
          <TabPane tabId={applicationUIList.NEWS}>
            {activeTab === applicationUIList.NEWS && (
              <News saveUISetting={saveUISetting} />
            )}
          </TabPane>
          <TabPane tabId={applicationUIList.USER_VERIFICATION_DOCUMENT}>
            {activeTab === applicationUIList.USER_VERIFICATION_DOCUMENT && (
              <UserVerificationDocument saveUISetting={saveUISetting} />
            )}
          </TabPane>
        </TabContent>
      </div>
    </div>
  );
};

export default ApplicationUI;